import { sendWhatsAppTestMessage } from '@/core/services/whatsapp/whatsapp-functions.service';
import type {
  SendWhatsAppTestMessageInput,
  SendWhatsAppTestMessageResponse,
} from '@/core/services/whatsapp/whatsapp-functions.service';

export class SendWhatsAppTestMessageUseCase {
  async execute(input: SendWhatsAppTestMessageInput): Promise<SendWhatsAppTestMessageResponse> {
    return sendWhatsAppTestMessage(input);
  }
}

